export const isOdooStockSyncEnabled = variant =>
    variant?.sync_odoo_stock ?? Boolean(variant?.odoo_id);

export const getOdooLinkRowStyle = (
    variant,
    catalogIds,
    { loading = false, error = false } = {}
) => {
    if (loading || error)
        return {};

    return {
        backgroundColor: catalogIds.has(String(variant?.odoo_id)) ?
            '#E8F5E9'
        :
            '#FFEBEE'
    };
};

const finiteValue = value => {
    if (value === null || value === undefined || value === '')
        return null;

    const number = Number(value);
    return Number.isFinite(number) ? number : null;
};

export const getOdooStockSyncState = variant => {
    if (!isOdooStockSyncEnabled(variant))
        return {
            color: 'default',
            label: 'Desactivada',
            description: 'Odoo se consulta, pero no modifica el stock ONL.'
        };

    const localStock = finiteValue(variant?.stock);
    const odooStock = finiteValue(variant?.odoo_data?.stock);
    const hasOdooReading = Boolean(
        String(variant?.odoo_data?.id || '').trim() ||
        String(variant?.odoo_data?.name || '').trim()
    );

    if (!hasOdooReading || odooStock === null)
        return {
            color: 'default',
            label: 'Pendiente',
            description: 'Aún no existe una lectura de inventario de Odoo.'
        };

    if (localStock === odooStock)
        return {
            color: 'success',
            label: 'Sincronizado',
            description: 'El stock ONL coincide con la última lectura de Odoo.'
        };

    return {
        color: 'info',
        label: 'Pendiente de sincronización',
        description: 'Los valores difieren y Odoo prevalecerá en la siguiente sincronización.'
    };
};
